module.exports = __webpack_public_path__ + "static/media/seaworld.434fd071.jpg";